import React from 'react';
import { Link, withRouter } from 'react-router-dom';
//styls
import { CardContainer, Header, Circles, HeaderIcon, SeparatorLine, ItemBox, CircleIconWrap } from './style';
//components
import { Icon } from '../Icons/Icons';
import { ProfileAvatar } from '../ProfileAvatar/ProfileAvatar';
//UI
import { Row } from '../../Layouts';
import { Text } from '../../UI/Text';
//tyles
import styled from 'styled-components';

import CheckOutline from '../../../Assets/Icons/check-outline.png';
import CheckFull from '../../../Assets/Icons/check-full.png';
import { displayInfo, displayMetric, displayTopLeaderboardLabel } from '../../../Utils';
import { detectTypeOfLeaderboard } from '../../App/pages/LeaderBoardsCarusel/LeaderBoardsCarusel';
import { config } from '../../../Configurations';

const WrapperCheckbox = styled.div`
    position: absolute;
    left: 8px;
    top: 8px;
    opacity: ${props => (props.selected ? 1 : 0.4)};

    &:hover {
        cursor: pointer;
    }
`;

// TODO: should be separete component with own styles
const CheckBoxIcon = ({ onClick, selected, ...props }) => (
    <WrapperCheckbox onClick={onClick} selected={selected}>
        <div style={{ width: '24px', height: '24px' }}>
            {selected ? (
                <img alt={'checkbox'} style={{ width: '24px', height: '24px' }} src={CheckFull} />
            ) : (
                <img alt={'checked'} style={{ width: '24px', height: '24px' }} src={CheckOutline} />
            )}
        </div>
    </WrapperCheckbox>
);

const ConditionalLinkWrapper = ({ hasLink, path, children, onClick }) =>
    hasLink ? (
        <Link to={path}>{children}</Link>
    ) : (
        <div onClick={onClick} style={{ cursor: 'pointer' }}>
            {children}
        </div>
    );

function LeaderboardCard({
    onSelect,
    isSelected,
    gradientColor,
    name,
    type,
    count,
    topList,
    currentUserPlace,
    match,
    userMetric,
    onLeaderboardSelect,
    initialModalType,
    selectLeaderboardType,
    ...props
}) {
    const MetaInfo = detectTypeOfLeaderboard(props.type, name);
    const LeaderboardIcon = MetaInfo.component;

    const carouselQuery = `?id=${props.id}`;
    const carouselPath = match.params.workoutId
        ? `/${match.params.profileId}/workout/${match.params.workoutId}/leaderboards/selected`
        : `/${match.params.profileId}/leaderboards/selected`;

    const selectLeaderBoard = () => {
        onLeaderboardSelect(initialModalType, {
            content_type: selectLeaderboardType,
            type: initialModalType,
            leaderboards: { data: [{ id: props.id }] },
        });
    };
    return (
        <ConditionalLinkWrapper
            hasLink={!onLeaderboardSelect}
            path={{
                pathname: carouselPath,
                search: carouselQuery,
            }}
            onClick={selectLeaderBoard}
        >
            <CardContainer bg={gradientColor}>
                <Header>
                    <Row fullHeight justify={'space-between'} style={{ position: 'relative' }}>
                        <CheckBoxIcon
                            name={props.id}
                            selected={isSelected(props.id)}
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();

                                onSelect(props.id);
                            }}
                        />
                        <div />

                        <CircleIconWrap>
                            <Circles>
                                <Icon.OvalGreen />
                            </Circles>

                            <HeaderIcon>
                                <Icon.Box size={'24x24'}>
                                    <LeaderboardIcon />
                                </Icon.Box>
                            </HeaderIcon>
                        </CircleIconWrap>

                        <div />
                    </Row>
                </Header>

                <div style={{ flexGrow: 1, marginTop: '15px' }}>
                    <div style={{ marginBottom: '5px' }}>
                        <Text small center opacity={'0.7'}>
                            {displayTopLeaderboardLabel(props)}
                        </Text>
                    </div>
                    <div>
                        <Text center large weight={'bolder'}>
                            {name}
                        </Text>
                        <div style={{ margin: '5px 0' }}>
                            <Text center small opacity={'0.7'} lineHeight={'1.2'}>
                                {displayInfo(props)}
                            </Text>
                        </div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        {topList.map((user, index) => {
                            if (currentUserPlace <= 3) {
                                return (
                                    <ItemBox key={index}>
                                        <UserOnBoard
                                            {...user}
                                            type={type}
                                            userMetric={userMetric}
                                            position={index + 1}
                                            withTropy={index === 0}
                                            image={user.smallImage}
                                        />
                                    </ItemBox>
                                );
                            } else {
                                if (index < 2) {
                                    return (
                                        <ItemBox key={index}>
                                            <UserOnBoard
                                                {...user}
                                                type={type}
                                                userMetric={userMetric}
                                                position={index + 1}
                                                image={user.smallImage}
                                                withTropy={index === 0}
                                            />
                                        </ItemBox>
                                    );
                                }
                            }
                        })}

                        {currentUserPlace > 3 && (
                            <ItemBox>
                                <IntoLine>
                                    <UserOnBoard
                                        position={currentUserPlace}
                                        type={type}
                                        userMetric={userMetric}
                                        metric={props.currentUser.metric}
                                        fullname={props.currentUser.fullName}
                                        image={props.currentUser.smallImage}
                                        yourScore={true}
                                    />
                                </IntoLine>
                            </ItemBox>
                        )}
                    </div>
                </div>

                {count > 3 && (
                    <div style={{ padding: '10px' }}>
                        <Row justify={'center'} align={'baseline'}>
                            <Text fontSize={'9'} opacity={'0.7'}>
                                and
                            </Text>
                            <div style={{ margin: '0 15px' }}>
                                <Text weight={'bold'}>{count - 3}</Text>
                            </div>
                            <Text fontSize={'9'} opacity={'0.7'}>
                                more...
                            </Text>
                        </Row>
                    </div>
                )}
            </CardContainer>
        </ConditionalLinkWrapper>
    );
}
// TODO: add match key from router
LeaderboardCard = withRouter(LeaderboardCard);

function UserOnBoard({ fullName, metric, type, position, score, withTropy, yourScore, image, userMetric, ...props }) {
    return (
        <div style={{ display: 'flex', width: '100%', margin: '3px 0' }}>
            <div
                style={{
                    width: '20%',
                    textAlign: 'right',
                    paddingRight: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                }}
            >
                <Text lineHeight={1.4} weight={300}>
                    {position}
                </Text>
            </div>

            <div style={{ width: '60%', display: 'flex', alignItems: 'center' }}>
                <div style={{ margin: '0 10px 0 0' }}>
                    <ProfileAvatar size={'small'} src={image ? `${config.baseUrl}/${image}` : ''} />
                </div>
                <Text textOverflow={'ellipsis'} nowrap overflow={'hidden'} lineHeight={1.4} weight={300}>
                    {fullName}
                    {yourScore && ' (You) '}
                </Text>

                {withTropy && (
                    <Icon.Box size={'12x12'}>
                        <Icon.Trophy />
                    </Icon.Box>
                )}
            </div>

            <div style={{ width: '20%', display: 'flex', alignItems: 'center' }}>
                <Text textOverflow={'ellipsis'} nowrap overflow={'hidden'} lineHeight={1.4} weight={300}>
                    {displayMetric(type, metric, userMetric)}
                </Text>
            </div>
        </div>
    );
}

function IntoLine({ children, ...rpops }) {
    return (
        <div>
            <SeparatorLine />
            {children}
            <SeparatorLine />
        </div>
    );
}

export { LeaderboardCard };



// WEBPACK FOOTER //
// ./src/UI/Components/LeaderboardCard/LeaderboardCard.js